<template>
  <permission-guard situation="site_configuration">
    <v-form>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="site.basicAuthName"
            class="mb-4"
            label="basic認証（ユーザー名）"
            style="width: 300px"
            required
          />
          <v-text-field
            v-model="site.basicAuthPw"
            class="mb-4 password-text"
            label="basic認証（パスワード）"
            type="text"
            style="width: 300px"
            required
          />
        </v-col>
      </v-row>
    </v-form>
    <v-spacer />
    <v-alert dense outlined type="error" style="width: 400px">
      <span class="caption">
        basic認証を全て空欄で保存すると、basic認証が解除されます。
      </span>
    </v-alert>
    <v-btn color="green darken-1" tile dark depressed @click="updateSite">
      更新
    </v-btn>
  </permission-guard>
</template>
<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'

export default {
  components: {
    PermissionGuard
  },
  props: {
    siteId: {
      type: Number,
      required: true
    }
  },
  data: () => {
    return {
      site: {}
    }
  },
  mounted: function () {
    axios.get(`/api/sites/${this.siteId}/edit`).then(
      ({ data }) => {
        this.site = data.data.attributes
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    updateSite () {
      const site = this.site
      const query = {
        site: {
          basicAuthName: site.basicAuthName,
          basicAuthPw: site.basicAuthPw
        }
      }
      axios.patch(`/api/sites/${site.id}`, query).then(
        () => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style>
.password-text input {
  font-family: text-security-disc;
  -webkit-text-security: disc;
}
</style>
